import { useMemo } from 'modules/core/hooks/useMemo'

import DocumentLocalStepsModal from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal'
import { WizardData } from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal/types'
import { Folder } from 'modules/documents/hooks/useGetFolders'

interface Props {
  onClose: () => void
  onDeleteFile: (i: number) => void
  onDropFiles: (files: File[]) => void
  onUploadFinished: () => Promise<unknown>
  folders: Folder[]
  isReadOnly: boolean
  featureFlagDocumentFolderPermissionsEnabled: boolean
}

const PayslipsStepsModal = ({
  onClose,
  onDeleteFile,
  onDropFiles,
  onUploadFinished,
  isReadOnly,
  folders,
  featureFlagDocumentFolderPermissionsEnabled = false,
}: Props) => {
  const payslipFolder = useMemo(
    () => folders.filter((folder) => folder.type === 'payslip' && !folder.parentFolder),
    [folders.map((folder) => folder.id).join(',')]
  )

  const initialData: WizardData = {
    distributionWorkflow: 'payslips',
    uploadType: 'manual_per_page',
    folderId: payslipFolder[0]?.id ?? null,
    combineFileName: '',
    numberSplitPages: 1,
    esignatureRequest: false,
    additionalSignersAccessIds: [],
    featureFlagDocumentFolderPermissionsEnabled: featureFlagDocumentFolderPermissionsEnabled,
  }

  return (
    <DocumentLocalStepsModal
      onClose={onClose}
      onDeleteFile={onDeleteFile}
      onDropFiles={onDropFiles}
      onUploadFinished={onUploadFinished}
      isReadOnly={isReadOnly}
      folders={folders}
      wizardData={initialData}
      selectedFolder={payslipFolder[0]}
    />
  )
}

export default PayslipsStepsModal
